<template>
  <div
    class="tw-grid tw-grid-cols-2 tw-gap-4"
    :style="{
      height: containerHeight + 'px',
    }"
  >
    <div
      class="tw-overflow-y-auto tw-h-full tw-pl-[15px] tw-ml-[-15px] tw-pr-2"
    >
      <slot name="left"></slot>
    </div>

    <div class="tw-overflow-y-auto tw-overflow-x-visible tw-h-full">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { getHeaderOffset } from '@app/application/behaviors/fixed-table-headers/utils'

interface Props {
  extraHeightOffset: number
}

// This height offset represents the distance from the bottom line of
// the navbar-tabs until the top line of the two-column layout container when the
// meeting card is expanded and scrolled into view (at the top of the viewport)
const props = withDefaults(defineProps<Props>(), {
  extraHeightOffset: 170,
})

/*
 * We set the container height based on the window height
 * minus the header offset and any extra offset passed as a prop.
 * This makes the container fit perfectly in the viewport without causing
 * overflow issues.
 * Then any container inside this layout can have a full height scrollable area.
 */
const containerHeight = computed(() => {
  return window.innerHeight - getHeaderOffset() - props.extraHeightOffset
})
</script>
